import { Col } from "react-bootstrap";
import React from "react";
import { Link } from "react-router-dom";
import Button from 'react-bootstrap/Button';

export const ProjectCard = ({title,description,imgUrl,link }) => {
  
  
  return (
   

    <Col size={12} sm={6} md={4}>
      <div className="proj-imgbx">
        <img src={imgUrl} />


        
        <div className="proj-txtx">
        <a href= {link} title={title}><h4>{title}</h4></a>
          <span>{description}</span>
        </div>
       
      </div>
    </Col>
  )
}
